export default "__VITE_ASSET__746622c9__"